export function generateYearsInterval(startYear: string, endYear?: string) {
  const parsedStartYear = parseInt(startYear, 10);
  const parsedEndYear: number = endYear ? parseInt(endYear, 10) : new Date().getFullYear();
  if (Number.isNaN(parsedStartYear) || Number.isNaN(parsedStartYear)) {
    return [];
  }
  const years = [];

  const minYear = Math.min(parsedStartYear, parsedEndYear);
  const maxYear = Math.max(parsedStartYear, parsedEndYear);

  for (let i = minYear; i <= maxYear; i += 1) {
    years.push(i.toString());
  }

  return years;
}
